import './App.css';
import Webpage from './webpage/Webpage';

function App() {
  return (
    <div className="App">
      <Webpage />
    </div>
  );
}

export default App;
